function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import "./search-input.scss";
import template from "./search-input.html";
import { getDayIndexOfWeek } from "redesign/shared/helpers/date-time";

export var FoodSearchComponent = {
  template: template,
  bindings: {
    withMealSelect: '<',
    onClose: "&",
    onSelect: "&" },

  controller: /*#__PURE__*/function () {FoodSearchComponentController.$inject = ["$q", "$scope", "$timeout", "$http", "$localStorage", "LayoutService", "MealPlanService", "FoodSearchModel", "gplansConf"];
    function FoodSearchComponentController($q, $scope, $timeout, $http, $localStorage, LayoutService, MealPlanService, FoodSearchModel, gplansConf) {
      "ngInject";_classCallCheck(this, FoodSearchComponentController);
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$q = $q;
      this.$http = $http;
      this.$localStorage = $localStorage;
      this.LayoutService = LayoutService;
      this.MealPlanService = MealPlanService;
      this.FoodSearchModel = FoodSearchModel;
      this.gplansConf = gplansConf;

      //this.filterItems = ['All', 'My Foods', 'Free Foods', 'Recent'];
      this.filterItems = ['All', 'Recent'];
      this.meals = [];
      this.foods = [];

      this.currentFilter = this.filterItems[0];
      this.foodQuery = '';
      this.currentFood = '';
      this.currentMeal = null;
      this.animateOnShow = false;
      this.foodSearchPromise = null;
      this.withMealSelect = true;
      this.isLoading = false;
      this.promises = [];
    }_createClass(FoodSearchComponentController, [{ key: "$onInit", value: function $onInit()

      {
        this.meals = this.MealPlanService.mealPlanForToday.meals;
        this.getRecentFoodNames();
      } }, { key: "$onChanges", value: function $onChanges(_ref)

      {var withMealSelect = _ref.withMealSelect;
        if (withMealSelect && typeof withMealSelect.currentValue === 'undefined') {
          this.withMealSelect = true;
        }
      } }, { key: "$postLink", value: function $postLink()

      {var _this = this;
        this.$q.resolve().
        then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 100);});}).
        then(function () {return angular.element('.ui-input-search').trigger('focus');}).
        then(function () {return _this.$q(function (rs, rj) {return _this.$timeout(rs, 500);});}).
        then(function () {return _this.animateOnShow = true;});

      } }, { key: "$onDestroy", value: function $onDestroy()

      {
      } }, { key: "getRecentFoodNames", value: function getRecentFoodNames()

      {
        this.recentFoods = this.$localStorage['recentFood'] || [];
        this.recentFoodNames = this.recentFoods.map(function (food) {
          return food.name;
        });
      } }, { key: "onSelectFilter", value: function onSelectFilter(

      filter) {
        if (this.currentFilter !== filter) {
          this.currentFilter = filter;
          if (this.currentFilter == 'All') {
            this.foods = [];
          } else
          {
            this.foods = this.$localStorage['recentFood'] || [];
          }
          this.reload();
        }
      } }, { key: "onCloseSeachModal", value: function onCloseSeachModal()

      {
        // this.$scope.$emit('closeSearchModal', false);
        this.onClose();

        this.currentFilter = this.filterItems[0];
        this.currentFood = '';
        this.currentMeal = '';
      } }, { key: "onSelectFood", value: function onSelectFood(

      meal) {
        if (this.currentFood !== meal) {
          this.currentFood = meal;
        } else {
          this.currentFood = '';
          this.currentMeal = '';
        }
      } }, { key: "onSelectMeal", value: function onSelectMeal(

      meal) {
        this.currentMeal !== meal ?
        this.currentMeal = meal :
        this.currentMeal = null;
      } }, { key: "addToRecentFood", value: function addToRecentFood(

      food) {
        var recentFoods = this.$localStorage['recentFood'] || [];
        var exist = false;
        for (var i = 0; i < recentFoods.length; i++) {
          var recentFood = recentFoods[i];
          if (recentFood.name === food.name) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          recentFoods.unshift(food);
        }
        if (recentFoods.length > 10) {
          recentFoods = recentFoods.slice(0, 10);
        }
        this.$localStorage['recentFood'] = recentFoods;
        this.getRecentFoodNames();
      } }, { key: "onAdd", value: function onAdd()

      {var _this2 = this;
        if (this.currentFilter == 'Recent') {
          this.currentFood.modal_calories = this.currentFood.calories;
          this.currentFood.modal_carbohydrates = this.currentFood.carbohydrates;
          this.currentFood.modal_fats = this.currentFood.fats;
          this.currentFood.modal_proteins = this.currentFood.proteins;
          if (this.withMealSelect) {
            this.onSelect({ data: { food: this.currentFood, meal: this.currentMeal } });
          } else
          {
            this.onSelect({ data: { food: this.currentFood } });
          }
        } else
        {
          var params;
          if (this.currentFood.nix_item_id) {
            params = { nix_item_id: this.currentFood.nix_item_id };
          } else
          {
            params = { food_name: this.currentFood.food_name };
          }
          this.FoodSearchModel.query(params).
          then(function (res) {
            res.modal_calories = res.calories;
            res.modal_carbohydrates = res.carbohydrates;
            res.modal_fats = res.fats;
            res.modal_proteins = res.proteins;
            _this2.addToRecentFood(res);
            if (_this2.withMealSelect) {
              _this2.onSelect({ data: { food: res, meal: _this2.currentMeal } });
            } else
            {
              _this2.onSelect({ data: { food: res } });
            }
          });
        }
      } }, { key: "reload", value: function reload()

      {var _this3 = this;
        if (this.currentFilter == 'Recent') {
          this.currentFood = '';
          if (!this.foodQuery) {
            this.foods = this.$localStorage['recentFood'] || [];
            return;
          }
          this.foods = this.$localStorage['recentFood'] || [];
          this.foods = this.foods.filter(function (food) {return food.name.includes(_this3.foodQuery);});
        } else
        {
          if (!this.foodQuery) {
            this.foods = [];
            return;
          }
          this.isLoading = true;
          var params = { 'q': this.foodQuery };
          this.$http.get(this.gplansConf.API_URL + '/api/v1/search-only-food/', { params: params }).
          then(function (res) {
            if (_this3.currentFilter == 'All') {
              _this3.foods = res.data;
            } else
            {
              _this3.foods = _this3.$localStorage['recentFood'] || [];
            }
          }).
          catch(function (res) {
            console.warn(res);
          }).
          finally(function () {
            _this3.isLoading = false;
          });
        }
        /*
           const foodSearchPromise = this.FoodSearchModel.query({q: this.foodQuery})
           .then(res=>{
           if ( this.promises.indexOf(foodSearchPromise) === this.promises.length -1 ) {
           if (!this.foodQuery) res = [];
           this.foods = res;
           }
           })
           .catch(res=>{console.warn(res)})
           .finally(()=>{
           this.isLoading = false
           });
             this.promises.push(foodSearchPromise);
            $ctrl.onSelect({data:{food:$ctrl.currentFood}})
           */



      } }]);return FoodSearchComponentController;}() };